module.exports = __webpack_public_path__ + "img/ezgif.com-webp-to-png (1).de8f0274.png";